export enum LOCALE_TYPE {
  JA = 'ja',
  EN = 'en',
  TW = 'zh_tw',
  HK = 'zh_hk',
  CN = 'zh_cn'
}

export enum API_ACCEPT_LANGUAGE {
  JA = 'ja',
  EN = 'en',
  TW = 'zh-TW',
  HK = 'zh-HK',
  CN = 'zh-CN'
}
